<script setup lang="ts">
/** Constitution Cover Page — SG Incorporation (Pre) · A4 한 장, 세로 균형 배치 */
import CddVarField from './cdd/CddVarField.vue';
import SgPreSigners from './SgPreSigners.vue';
import { SG_PRE_SIGNER_KEYS } from './cdd/sgPreSignersContext';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc const-cover">
    <div class="const-top">
      <div class="doc-meta">
        Company Registration No.:
        <CddVarField field-key="company_registration_no" label="Company Registration No." />
      </div>
      <div class="doc-meta const-act">THE COMPANIES ACT 1967 (CAP. 50)</div>
      <div class="doc-meta">PRIVATE COMPANY LIMITED BY SHARES</div>
    </div>

    <div class="const-hero">
      <div class="doc-lbl-title const-title">CONSTITUTION</div>
      <div class="doc-meta">OF</div>
      <div class="doc-company const-company">
        <CddVarField field-key="company_name" label="Company Name" />
      </div>
      <div class="doc-p const-incorp">
        INCORPORATED ON
        <CddVarField field-key="date_of_incorporation" label="Date of Incorporation" />
      </div>
    </div>

    <div class="const-cert">
      <div class="doc-lbl-title">AGREED &amp; CONFIRMED</div>
      <div class="doc-meta">CERTIFIED TRUE COPY</div>
      <div class="doc-p const-cert-fields">
        <CddVarField field-key="authorized_person_name" label="Authorized Person Name" />
      </div>
      <div class="doc-p">
        <CddVarField field-key="authorized_person_title" label="Authorized Person Title" />
      </div>
      <div class="doc-p">
        Date: <CddVarField field-key="certification_date" label="Certification Date" />
      </div>
    </div>

    <div class="const-signers">
      <p class="doc-sec-title">Signatories</p>
      <SgPreSigners :var-key="SG_PRE_SIGNER_KEYS.constitution" />
    </div>

    <div class="const-foot">
      LODGED IN THE OFFICE OF THE<br />
      ACCOUNTING &amp; CORPORATE REGULATORY AUTHORITY, SINGAPORE
    </div>
  </div>
</template>

<style scoped>
/* A4 프레임(.a4-sheet) 안에서 세로로 자연스럽게 분배 */
.const-cover {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  text-align: center;
  height: 100%;
  min-height: calc(297mm - 36mm); /* A4 − 상하 패딩(18mm×2) */
  box-sizing: border-box;
}

.const-top {
  flex: 0 0 auto;
}

.const-hero {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
}

.const-cert {
  flex: 0 0 auto;
  padding: 4px 0;
}

.const-signers {
  flex: 0 0 auto;
  padding: 4px 0 8px;
}

.const-foot {
  flex: 0 0 auto;
  padding-top: 8px;
  font-size: 11px;
  line-height: 1.55;
  color: #333;
}

.const-act {
  margin-top: 14px;
}

.const-title {
  margin: 0 0 6px;
  letter-spacing: 0.14em;
  font-size: 18px;
}

.const-company {
  margin-top: 10px;
  font-size: 17px;
}

.const-incorp {
  margin-top: 16px;
  margin-bottom: 0;
}

.const-cert-fields {
  margin-top: 14px;
}
</style>
